export default "__VITE_ASSET__CPn9wH6R__"